import { toast } from 'react-toastify';
import appApi from '../../../../api/app-api';
import globalSettingsStores from '../../../../stores/settings-stores';
import { displayErrorText } from '../../../../api/errors/api-error-codes';

export const deletePollOperation = async (
  pollId: number,
  setLoading: (isLoading: boolean) => void,
  closeDialog: () => void,
) => {
  try {
    setLoading(true);
    const res = await appApi.deleteAbstractPoll(pollId);
    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      closeDialog();
      return;
    } else {
      await globalSettingsStores.fetchSetting();
      toast.success('המשוב נמחק בהצלחה');
      setLoading(false);
      closeDialog();
    }
  } catch (e) {
    toast.error('לא ניתן לבצע את הפעולה, נסה שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
